<footer class="footer-box">
  <div class="footer-container">
    <!-- Brand -->
    <div class="footer-section footer-brand">
      <a routerLink="/" class="footer-title">
        {{ TITLE.ZIP_UTILS }}
      </a>
      <p class="footer-tagline">
        A free utility platform for text, links, and QR tools.
      </p>
    </div>

    <!-- Tools -->
    <div class="footer-section">
      <h4 class="footer-heading">Tools</h4>
      <ul class="footer-list">
        <li><a routerLink="/text/">Online Text Transfer</a></li>
        <li><a routerLink="/url/">URL Shortener</a></li>
        <li><a routerLink="/qr/">QR Code Generator</a></li>
      </ul>
    </div>

    <!-- Legal -->
    <div class="footer-section">
      <h4 class="footer-heading">Legal</h4>
      <ul class="footer-list">
        <li>
          <a
            href="https://drive.google.com/file/d/1Ed_Can1LipXpwhIEqy_igWL9qxn28tMQ/view"
            target="_blank"
            rel="noopener"
          >
            Legal & Policy
          </a>
        </li>
      </ul>
    </div>

    <!-- Contact -->
    <div class="footer-section">
      <h4 class="footer-heading">Contact</h4>
      <ul class="footer-list">
        <li>
          <a href="mailto:ziputils25&#64;gmail.com">
            ziputils25&#64;gmail.com
          </a>
        </li>
      </ul>
    </div>
  </div>

  <div class="footer-bottom">
    © {{ currentYear }} Zip-Utils · All rights reserved
  </div>
</footer>
